import { render, staticRenderFns } from "./prodect_data.vue?vue&type=template&id=bd1d62cc&"
import script from "./prodect_data.vue?vue&type=script&lang=js&"
export * from "./prodect_data.vue?vue&type=script&lang=js&"
import style0 from "./prodect_data.vue?vue&type=style&index=0&id=bd1d62cc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports